<template>
  <div class="dashboard">
    <top-header></top-header>
    
    <div class="about-team  pt-5 pb-3">
      <b-container class="px-2 py-2">
        <b-row>
          <b-col class="px-3 text-center">
            <b-img src="../assets/404_v2.png" style="width:70%"></b-img>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <bottom-footer></bottom-footer>
    <b-modal id="modal-status" hide-footer>
      <template v-slot:modal-title>
        Status
      </template>
      <div class="d-block text-center">
        <h5>{{modal.msg}}</h5>
      </div>
      <b-link class="mt-3 button btn-solid float-right" @click="$bvModal.hide('modal-status')">Close Me</b-link>
    </b-modal>

    
  </div>
</template>

<script>

import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";

export default {
  name: "Home",
  components: {
    "top-header": Header,
    "bottom-footer": Footer,
  },
  beforeCreate: function() {
      document.body.className = 'promo';
  },
  mounted(){
    let recaptchaScript = document.createElement('script');
      recaptchaScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=AW-600938697');
      document.head.appendChild(recaptchaScript);

      let recaptchaScript1 = document.createElement('script');
      recaptchaScript1.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=AW-600938697');
      document.head.appendChild(recaptchaScript1);

      let s1 = document.createElement('script');
      s1.setAttribute('src', 'https://www.alluraa.com/js/js_main.js');
      document.head.appendChild(s1);
      
		this.init();
	},
  data() {
    return {
      form_alert: [],
      terms_condition: 'not_accepted',
      modal: {
        msg: ''
      },
      TYPE_SELLER: 'seller',
      TYPE_ADVICER: 'sales-advisor',
      customer:{
        prefix: 'mr',
        role: 'seller',
        fullname: '',
        mobile: '',
        email: '',
        location: '',
        workarea: ""
      },
      team:[
        {id:1, img:'https://www.alluraa.com/media/images/quote-1.png', name:'Mr. Vijay Shanker', text:'Alluraa is an attempt to make e-commerce more inclusive, progressive, and impactful for everyone and look towards newer avenues for business growth and opportunities that give people further confidence in e-commerce platforms potential.'},
        {id:2, img:'https://www.alluraa.com/media/images/quote-2.png', name:'Mr. Bhanu Mishra', text:'E-commerce today is paving the way for businesses and retailers, but it also has the scope to uplift the ordinary people who dream of having their businesses but lack the investment. Alluraa is a way to realize that dream, to empower people from across the country to become entrepreneurs and make a living.'}
      ],
      states: ['Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat','Haryana','Himachal Pradesh','Jharkhand','Karnataka','Kerala','Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Odisha','Punjab','Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh','Uttarakhand','West Bengal','Andaman and Nicobar Islands','Chandigarh','Delhi','Jammu and Kashmir','Ladakh','Lakshadweep','Puducherry'],
      workarea_salesadvisor: ['House Maker','Self Employed','Sales & Marketing','Advertising','Logistics','Hospitality','Financial Service','Other'],
      workarea_seller: ['Cosmetics','Electronics','Fashion','Herbal Products','Organic Food','Toys & baby','Other'],
      workarea_options: [],
      mainProps: { fluidGrow: true, class: 'm1' },
      mainblankProps: { blank: true, blankColor: '#b7b7b7', width: 400, height: 100, fluidGrow: true, class: 'm1' },
      iconImg: { width: 100, height: 100, fluidGrow: true, class: 'icon' },
      socialImg: { width: 300, height: 300, fluidGrow: true, class: 'm1' },
      instagramfeed: [],
      feedindex: 4,
      swiperOption: {
        direction: 'horizontal',
        initialSlide: 0,
        slidesPerGroup: 1,
        loop: false,
        watchSlidesVisibility: true,
        loopFillGroupWithBlank: true,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 80
            },
            480: {
                slidesPerView: 1,
                spaceBetween: 80
            },
            640: {
                slidesPerView: 1,
                spaceBetween: 80
            },
            960: {
                slidesPerView: 2,
                spaceBetween: 60
            },
            1124: {
                slidesPerView: 2,
                spaceBetween: 80
            }
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        on: {
            init: function () {
                console.log('swiper initialized');
            },
            slideChange: function() {
                console.log('slide changed');
            }
        },
        fadeEffect: {
            crossFade: true
        },
      }
    }
  },
  methods: {
    handleResize(){
      var self  = this;
      //this.window.width = window.innerWidth;
      //this.window.height = window.innerHeight;
      if(window.innerWidth < 700){
        self.feedindex = 2;
      }
    },
    init(){
      var self = this;
      if(self.$route.params.param_role){
        self.customer.role = self.$route.params.param_role;
      //  self.customer.workarea = self['workarea_'+self.$route.params.param_role];
      }
      //alert(self.customer.role.replace('-',''));
      self.workarea_options = self['workarea_'+self.customer.role.replace('-','')];

      //window.addEventListener('resize', self.handleResize);
      self.handleResize();

      

      const instagramRegExp = new RegExp(/<script type="text\/javascript">window\._sharedData = (.*);<\/script>/)

      const fetchInstagramPhotos = async (accountUrl) => {
        const response = await self.axios.get(accountUrl)
        const json = JSON.parse(response.data.match(instagramRegExp)[1])
        const edges = json.entry_data.ProfilePage[0].graphql.user.edge_owner_to_timeline_media.edges.splice(0, 12)
        const photos = edges.map(({ node }) => {
          return {
            url: `https://www.instagram.com/p/${node.shortcode}/`,
            thumbnailUrl: node.thumbnail_src,
            displayUrl: node.display_url,
            caption: node.edge_media_to_caption.edges[0].node.text
          }
        })
        return photos
      }

      (async () => {
        try {
          self.instagramfeed = await fetchInstagramPhotos('https://www.instagram.com/alluraashop/');
          
          /*photos.forEach(el => {
          console.log(el.thumbnailUrl+" "+el.caption);
            const a = document.createElement('a')
            const img = document.createElement('img')

            a.setAttribute('href', el.url)
            a.setAttribute('target', '_blank')
            a.setAttribute('rel', 'noopener noreferrer')
            a.classList.add('instagram-photo')

            img.setAttribute('src', el.thumbnailUrl)
            img.setAttribute('alt', el.caption)
            
            a.appendChild(img)
            container.appendChild(a)
          })*/
        } catch (e) {
          console.error('Fetching Instagram photos failed', e)
        }
      })()

      //self.customer.workarea = 
      //alert(self['workarea_'+self.customer.role]);
    },
    validateemail(email){
      var atposition=email.indexOf("@");  
      var dotposition=email.lastIndexOf(".");  
      if (atposition<1 || dotposition<atposition+2 || dotposition+2>=email.length){ 
        return false;  
      }else{
        return true;
      }
    },
    submitRegistration(){
      var self = this;
      var valid = true;
      self.form_alert = [];
      if(self.customer.fullname == ''){
        //self.form_alert.push("Full name is required!");
        valid = false;
      }
      if(self.customer.email == '' && self.customer.mobile == '' ){
        //self.form_alert.push("Email or mobile is required!");
        valid = false;
      }
      /*if(self.terms_condition == 'not_accepted'){
        //self.modal.msg = "Please accept terms and condition!";
        //self.$bvModal.show('modal-status');
        self.form_alert.push("Terms and condition is required!");
        valid = false;
        //return;
      }*/
      var mobile = self.customer.mobile;
      if(mobile.length < 10){
        self.form_alert.push('Please add a valid mobile number.');
        valid = false;
      }
      if(self.customer.workarea == ''){
        valid = false;
      }
      
      if(!self.validateemail(self.customer.email)){
        self.form_alert.push('Please add a valid email.');
        self.form_alert.push('All fields are mandatory.');
        valid = false;
      }else{
        console.log('Valid email format.!');
      }

      if(valid == false){
        return;
      }

      var workarea = '';
      if(self.customer.workarea == 'Other'){
        workarea = self.customer.other;
      }else{
        workarea = self.customer.workarea;
      }
      
			self.axios.post(self.$root.WEBURL+'registration', {
        prefix: self.customer.prefix,
        fullname: self.customer.fullname,
        email: self.customer.email,
        mobile: self.customer.mobile,
        role: self.customer.role,
        location: self.customer.location,
        workarea: workarea
			})
			.then(function (response) {
        
				if(response.data.error == 0 || response.data.error == '0'){
          if(self.customer.role == self.TYPE_SELLER){
            self.modal.msg = "Thanks for successfully registering your profile as a seller!";
          }else{
            self.modal.msg = "Thanks for successfully registering your profile as a sales advisor!";
          }
          
          self.customer = {
            prefix: 'mr',
            role: self.TYPE_SELLER,
            fullname: '',
            mobile: '',
            email: '',
            workarea: '',
            location: '',
            other: ''
          };
          self.$bvModal.show('modal-status');
				}else if(response.data.error == 1){
          self.modal.msg = "Registration Failed! Try agin later!";
					self.$bvModal.show('modal-status');
				}else if(response.data.error == 2){
          self.modal.msg = "Registration Failed! Email or mobile allready exist!";
					self.$bvModal.show('modal-status');
				}
			})
			.catch(function (error) {
				alert(error);
			});
    }
  }
};
</script>
